import { RichText, HeroMedia, SEO, SEOProps } from '@islandsstofa/react'
import SeeAll from '@cmp/sections/SeeAll'
import System from '@cmp/sections/System'

export default {
  PrismicSupportBodySystem: {
    component: System,
    dataToProps (data: any) {
      return {
        programName: data.primary.program,
        options: data.items
          .filter((parameter: any, value: any) => parameter && value !== null)
          .reduce((acc: any, item: any) => {
            acc[item.parameter] = item.value
            return acc
          }, {})
      }
    }
  },
  PrismicSupportBodySeeAll: {
    component: SeeAll,
    dataToProps (data: any) {
      return {
        text: data.primary.text,
        type: data.primary.type
      }
    }
  },

  PrismicSupportBodySeo: {
    component: SEO,
    dataToProps: (data: any): SEOProps => ({
      title: data.primary.override_title,
      description: data.primary.override_description,
      image: data.primary.override_image,
      keywords: data.primary.override_keywords
    })
  },

  PrismicSupportBodyRichtext: {
    component: RichText,
    dataToProps (data: any) {
      return {
        html: data.primary.content.html
      }
    }
  },
  PrismicSupportBodyHeroMedia: {
    component: HeroMedia,
    dataToProps (data: any) {
      const {
        primary: {
          caption,
          single_image: singleImage,
          video,
          firstonpage: firstOnPage
        },
        items: gallery
      } = data

      return {
        caption,
        singleImage,
        video,
        gallery,
        firstOnPage
      }
    }
  }
}
